import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/utils.ts';

/** What a page shows when there is nothing to list: an icon, a sentence, maybe an action. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  ...rest
}: {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <div
      className={cn(
        'border-border bg-card/50 flex flex-col items-center justify-center rounded-card border border-dashed px-6 py-14 text-center',
        className,
      )}
      {...rest}
    >
      <span className="bg-brand-soft text-brand-soft-foreground mb-3 grid size-11 place-items-center rounded-xl">
        <Icon className="size-5" aria-hidden />
      </span>
      <p className="font-medium">{title}</p>
      {description && <p className="text-muted-foreground mt-1 max-w-sm text-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
